const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/auth-error.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { authErrorSeveritySchema } from '@/common/components/error/AuthError';
const searchSchema = z.object({
  message: z.string().optional(),
  severity: authErrorSeveritySchema.optional().catch(undefined)
});
export const Route = createFileRoute('/(unauthenticated)/auth-error')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(searchSchema),
  beforeLoad: ({
    search
  }) => {
    // Auth0's error description for an already-used/expired invite mentions "invitation" — route to the dedicated invite-error screen instead.
    if (search.message?.includes('invitation')) {
      throw redirect({
        to: '/organizations/invites/error',
        search: {
          message: search.message
        }
      });
    }
  }
});